import React from "react";
import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow
} from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "300px"
    }
  }
};

class WorkProcessTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
    };
    this.dataGridRef = React.createRef();
  }

  render() {
    const {
      processList,
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div className={root}>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          ref={this.dataGridRef}
          wordWrapEnabled={true}
          dataSource={processList}
          errorRowEnabled={false}
          showBorders
        >
          {columns.map(column => (
            <Column key={column.dataField} {...column} />
          ))}
          <FilterRow visible={true} />
          <Scrolling mode="virtual" />
          <LoadPanel enabled/>
        </DataGrid>
      </div>
    );
  }
}

export default withStyles(styles)(WorkProcessTable);
